import React from "react";
import { Card, Row, Col, Button, Badge, ListGroup } from "react-bootstrap";
import { BsTrash } from "react-icons/bs";
import { FaUsers, FaUserShield, FaUserTie } from "react-icons/fa";

function ResourceAllocationList({ resourceAllocations, onEdit, onDelete }) {
  return (
    <div className="hierarchy-wrapper">
      <Row>
        {resourceAllocations?.map((data) => (
          <Col md={6} key={data._id}>
            <Card className="mb-3">
              <Card.Body>
                <h5>
                  <FaUserShield color="#c607c6" /> {data?.assistantSuperadmin?.name}{" "}
                  <Badge bg="secondary">Asst. Superadmin</Badge>
                </h5>

                <div style={{ marginLeft: "1.5rem", marginTop: "0.5rem" }}>
                  {data?.resource?.map((resource) => (
                    <div key={resource?.manager?._id} className="mb-2">
                      <h6>
                        <FaUserTie color="#3a63a8" /> {resource?.manager?.name}{" "}
                        <Badge bg="secondary">Manager</Badge>
                      </h6>
                      <div style={{ marginLeft: "1.5rem" }}>
                        {resource.staffs?.length > 0 ? (
                          <ListGroup>
                            {resource.staffs.map((staff) => (
                              <ListGroup.Item key={staff._id}>
                                <FaUsers color="#069d57" /> {staff.name}{" "}
                                <Badge bg="secondary">Staff</Badge>
                              </ListGroup.Item>
                            ))}
                          </ListGroup>
                        ) : (
                          <small>No staff assigned</small>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-3 text-end">
                  <Button size="sm" onClick={() => onDelete(data.resourceAllocationIds)}>
                    <BsTrash />
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default ResourceAllocationList;